import { Plus, Trash2, Scale } from "lucide-react";

const inputCls = "w-full h-9 px-3 rounded-md bg-[#0B0F17] border border-[#242C3D] text-sm focus:border-indigo-500 focus:outline-none";

export const LegalEditor = ({ legal, setLegal, onRemove }) => {
  const parties = legal.parties || [];
  const setParties = (p) => setLegal({ ...legal, parties: p });
  const upd = (i, patch) => setParties(parties.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  return (
    <div data-testid="legal-editor">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-display font-semibold">Privacy Policy &amp; Terms links</h3>
        {parties.length < 3 && (
          <button type="button" data-testid="legal-add-party" onClick={() => setParties([...parties, { name: "", privacy_url: "", terms_url: "" }])}
            className="h-8 px-2.5 rounded-md border border-dashed border-[#2f3a50] hover:border-indigo-500 text-xs text-slate-400 hover:text-white flex items-center gap-1.5 transition-colors">
            <Plus className="w-3 h-3" /> <Scale className="w-3.5 h-3.5" /> Party
          </button>
        )}
      </div>
      <p className="text-xs text-slate-500 mb-4">Up to 3 parties (e.g. client, sponsor, your company). Tick “Link legal parties” on an opt-in to show their links inside that checkbox.</p>
      <div className="space-y-2">
        {parties.map((p, i) => (
          <div key={i} data-testid={`legal-party-editor-${i}`} className="grid sm:grid-cols-[1fr_1.3fr_1.3fr_auto] gap-2 rounded-md border border-[#242C3D] bg-[#0B0F17]/60 p-3">
            <input data-testid={`legal-party-name-${i}`} value={p.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Party name, e.g. Cisco" className={inputCls} />
            <input data-testid={`legal-party-privacy-${i}`} value={p.privacy_url} onChange={(e) => upd(i, { privacy_url: e.target.value.trim() })} placeholder="Privacy Policy URL (https://…)" className={inputCls} />
            <input data-testid={`legal-party-terms-${i}`} value={p.terms_url} onChange={(e) => upd(i, { terms_url: e.target.value.trim() })} placeholder="Terms & Conditions URL (https://…)" className={inputCls} />
            <button type="button" data-testid={`legal-party-delete-${i}`} onClick={() => onRemove(i)}
              className="h-9 w-9 grid place-items-center rounded-md text-slate-400 hover:text-rose-400 hover:bg-white/5"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
      {parties.length > 0 && (
        <label className="mt-3 flex items-center gap-2 text-xs text-slate-300 cursor-pointer">
          <input type="checkbox" data-testid="legal-require-agree" checked={!!legal.require_agree} onChange={(e) => setLegal({ ...legal, require_agree: e.target.checked })} className="accent-indigo-500" />
          Require an “I agree to the Privacy Policy and Terms &amp; Conditions” checkbox before submitting
        </label>
      )}
    </div>
  );
};
